var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 26.25C16.2426 26.25 17.25 25.2426 17.25 24L17.25 17.25H24C25.2426 17.25 26.25 16.2426 26.25 15C26.25 13.7574 25.2426 12.75 24 12.75H17.25L17.25 6C17.25 4.75736 16.2426 3.75 15 3.75C13.7574 3.75 12.75 4.75736 12.75 6L12.75 12.75H6C4.75736 12.75 3.75 13.7574 3.75 15C3.75 16.2426 4.75736 17.25 6 17.25H12.75L12.75 24C12.75 25.2426 13.7574 26.25 15 26.25Z",
    fill: "#585C91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.2c99b758.svg";
export { ForwardRef as ReactComponent };